<template>
  <div
    class="modal"
    style="display:block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span>Add a New Action</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <button
                v-for="(category, index) in actionCategories"
                :key="index"
                class="btn btn-primary col-sm-12"
                @click="open(category.id)"
              >
                {{ category.name }}
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ActionCategories
} from '@/utils/dictionaries'
export default {
  name: 'ModalCreateAction',
  computed: {
    actionCategories() {
      return ActionCategories
    }
  },
  methods: {
    open(id) {
      this.$emit('open', {
        id
      })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &-header {
    span {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalCreateAction.vue